export default __webpack_public_path__ + "static/media/d_contract.c2438994.avif";